import { FC } from 'react';
import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import { typograf } from '@/shared/utils/typograf';

interface Props {
  className?: string;
  children?: string;
}

export const HtmlContent: FC<Props> = ({ className, children }) => {
  return (
    <div
      className={twMerge(cvaRoot(), className)}
      dangerouslySetInnerHTML={{
        __html: typograf.execute(children ?? ''),
      }}
    />
  );
};

const cvaRoot = cva([
  'HtmlContent-cvaRoot',
  ' [&_p:not(:last-child)]:my-2.4 [&_p:first-child]:!mt-0',
  ' [&_ul:not(:last-child)]:my-2.4 [&_ul:first-child]:!mt-0',
  ' [&_li:not(:last-child)]:my-0.8 [&_li:first-child]:!mt-0',
]);
